var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioMute = function SvgAudioMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    fill: "none",
    viewBox: "0 0 22 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2 12.63a1 1 0 0 1-1-1V6.52a1 1 0 0 1 1-1h3.06l5.6-3.56v14.23l-5.6-3.56H2ZM15 6l6 6M21 6l-6 6",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgAudioMute;